import { LandingType } from '~/enums/LandingType';

export const useSeoStore = () => {
  const { locale: localeI18n } = useI18n();

  const getTitleHome = (landing: LandingType) => {
    switch (landing) {
      case LandingType.SX:
        switch (localeI18n.value) {
          case 'en':
            return 'Proxy marketplace with cleanest rating';
          case 'ru':
            return 'Прокси для бизнеса: мобильные, резидентные, корпоративные — SX.ORG';
          default:
            return 'Proxy marketplace with cleanest rating';
        }
      default:
        return landing;
    }
  };

  const getDescriptionHome = (landing: LandingType) => {
    switch (landing) {
      case LandingType.SX:
        switch (localeI18n.value) {
          case 'en':
            return 'Reliable proxies for any task: mobile, residential, corporate. Over 12 million IPs in 235 countries. Pay-as-you-go pricing from $0.7/GB. Try for free today!';
          case 'ru':
            return 'Надежные прокси для любых задач: мобильные, резидентные, корпоративные. Более 12 млн IP в 235 странах. Оплата по трафику от $0.7/GB. Попробуйте бесплатно!';
          default:
            return 'Reliable proxies for any task: mobile, residential, corporate. Over 12 million IPs in 235 countries. Pay-as-you-go pricing from $0.7/GB. Try for free today!';
        }
      default:
        return '';
    }
  };

  const getTitlePartners = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Our partners | SX.ORG';
      case 'ru':
        return 'Наши партнеры | SX.ORG';
      default:
        return 'Our partners | SX.ORG';
    }
  }

  const getDescriptionPartners = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Information about our partners';
      case 'ru':
        return 'Информация о наших партнерах';
      default:
        return 'Information about our partners';
    }
  };

  const getTitleGeo = (landing: LandingType) => {
    switch (landing) {
      case LandingType.SX:
        switch (localeI18n.value) {
          case 'en':
            return 'Proxies in 235 Countries Worldwide — SX.ORG';
          case 'ru':
            return 'Прокси из 235 стран мира — SX.ORG';
          default:
            return 'Proxies in 235 Countries Worldwide — SX.ORG';
        }
      default:
        return landing;
    }
  };

  const getTitleErrorPage = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Something went wrong | SX.ORG';
      case 'ru':
        return 'Что-то пошло не так | SX.ORG'
      default:
        return 'Something went wrong | SX.ORG';
    }
  }

  const getDescriptionGeo = (landing: LandingType) => {
    switch (landing) {
      case LandingType.SX:
        switch (localeI18n.value) {
          case 'en':
            return 'Over 12 million high-quality IP addresses in 235 countries. Mobile, residential, and corporate proxies with flexible pay-as-you-go pricing for all your needs.';
          case 'ru':
            return 'Более 12 млн высококачественных IP-адресов из 235 стран. Мобильные, резидентные и корпоративные прокси с гибкой моделью оплаты для любых задач.';
          default:
            return 'Over 12 million high-quality IP addresses in 235 countries. Mobile, residential, and corporate proxies with flexible pay-as-you-go pricing for all your needs.';
        }
      default:
        return landing;
    }
  };

  const getTitleCompare = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Compare Proxy Providers: Choose the Best with SX.ORG';
      case 'ru':
        return 'Сравнение прокси-провайдеров: выберите лучшее с SX.ORG';
      default:
        return 'Compare Proxy Providers: Choose the Best with SX.ORG';
    }
  };

  const getDescriptionCompare = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Discover how SX.ORG outperforms other providers in quality, pricing, and proxy network features.';
      case 'ru':
        return 'Узнайте, как SX.ORG превосходит других провайдеров по качеству, стоимости и функционалу прокси-сетей.';
      default:
        return 'Discover how SX.ORG outperforms other providers in quality, pricing, and proxy network features.';
    }
  };

  const getMobileProxyTitle = (landing: LandingType) => {
    switch (landing) {
      case LandingType.SX:
        switch (localeI18n.value) {
          case 'en':
            return 'Mobile Proxies with Unlimited Rotation — SX.ORG';
          case 'ru':
            return 'Мобильные прокси с безлимитной ротацией — SX.ORG';
          default:
            return 'Mobile Proxies with Unlimited Rotation — SX.ORG';
        }
      default:
        return landing;
    }
  };

  const getMobileProxyDescription = (landing: LandingType) => {
    switch (landing) {
      case LandingType.SX:
        switch (localeI18n.value) {
          case 'en':
            return '4 million mobile proxies supporting 3G/4G/5G. High-speed connections, ASN targeting, and prices starting at $6/GB. Try for free today!';
          case 'ru':
            return '4 млн мобильных прокси с поддержкой 3G/4G/5G. Высокая скорость, ASN-таргетинг, доступ от $6/GB. Попробуйте бесплатно!';
          default:
            return '4 million mobile proxies supporting 3G/4G/5G. High-speed connections, ASN targeting, and prices starting at $6/GB. Try for free today!';
        }
      default:
        return landing;
    }
  };

  const getResidentProxyTitle = (landing: LandingType) => {
    switch (landing) {
      case LandingType.SX:
        switch (localeI18n.value) {
          case 'en':
            return 'Residential Proxies with IP Rotation — SX.ORG';
          case 'ru':
            return 'Резидентные прокси с ротацией IP — SX.ORG';
          default:
            return 'Residential Proxies with IP Rotation — SX.ORG';
        }
      default:
        return landing;
    }
  };

  const getResidentProxyDescription = (landing: LandingType) => {
    switch (landing) {
      case LandingType.SX:
        switch (localeI18n.value) {
          case 'en':
            return 'Over 7 million residential proxies from 235 countries. Realistic connections, prices from $4/GB, unlimited IP rotation. Test for free!';
          case 'ru':
            return 'Более 7 млн резидентных прокси из 235 стран. Максимально приближенная к реальности работа. Цены от $4/GB. Безлимитная ротация. Тестируйте бесплатно!';
          default:
            return 'Over 7 million residential proxies from 235 countries. Realistic connections, prices from $4/GB, unlimited IP rotation. Test for free!';
        }
      default:
        return landing;
    }
  };

  const getCorporateProxyTitle = (landing: LandingType) => {
    switch (landing) {
      case LandingType.SX:
        switch (localeI18n.value) {
          case 'en':
            return 'Corporate Proxies for Business — SX.ORG';
          case 'ru':
            return 'Корпоративные прокси для бизнеса — SX.ORG';
          default:
            return 'Corporate Proxies for Business — SX.ORG';
        }
      default:
        return landing;
    }
  };

  const getCorporateProxyDescription = (landing: LandingType) => {
    switch (landing) {
      case LandingType.SX:
        switch (localeI18n.value) {
          case 'en':
            return 'High-performance corporate proxies with 3 IP rotation modes. Pricing starts at $0.7/GB. No KYC, flexible rates, and free testing available!';
          case 'ru':
            return 'Высокопроизводительные корпоративные прокси с 3 видами ротации IP. От $0.7/GB. Без KYC, гибкие тарифы и возможность тестирования бесплатно!';
          default:
            return 'High-performance corporate proxies with 3 IP rotation modes. Pricing starts at $0.7/GB. No KYC, flexible rates, and free testing available!';
        }
      default:
        return landing;
    }
  };

  const getOurProxyTitle = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Our Proxies — Mobile, Residential, and Corporate';
      case 'ru':
        return 'Наши прокси — Мобильные, резидентные и корпоративные';
      default:
        return 'Our Proxies — Mobile, Residential, and Corporate';
    }
  }

  const getOurProxyDescription = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Choose high-quality mobile, residential, and corporate proxies with pay-as-you-go pricing. Ideal for business and marketing. Try for free.';
      case 'ru':
        return 'Выбирайте качественные мобильные, резидентные и корпоративные прокси с оплатой по трафику. Подходят для бизнеса и маркетинга. Попробуйте бесплатно.';
      default:
        return 'Choose high-quality mobile, residential, and corporate proxies with pay-as-you-go pricing. Ideal for business and marketing. Try for free.';
    }
  }

  const getDevelopersTitle = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'API for Developers — SX.ORG';
      case 'ru':
        return 'API для разработчиков — SX.ORG';
      default:
        return 'API for Developers — SX.ORG';
    }
  }

  const getDevelopersDescription = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Comprehensive API documentation for integration with SX.ORG. Easily configure access to mobile, residential, and corporate proxies.';
      case 'ru':
        return 'Полная документация API для интеграции с SX.ORG. Настраивайте доступ к мобильным, резидентным и корпоративным прокси легко и быстро.';
      default:
        return 'Comprehensive API documentation for integration with SX.ORG. Easily configure access to mobile, residential, and corporate proxies.';
    }
  }

  const getTitleAbout = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'About SX.ORG — Reliable Proxies for Business';
      case 'ru':
        return 'О компании SX.ORG — Надежные прокси для бизнеса';
      default:
        return 'About SX.ORG — Reliable Proxies for Business';
    }
  }

  const getDescriptionAbout = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Learn more about SX.ORG — a leader in proxy services. We provide high-quality mobile, residential, and corporate proxies with flexible pricing.';
      case 'ru':
        return 'Узнайте больше о SX.ORG — лидере в предоставлении прокси-сервисов. Мы предлагаем качественные мобильные, резидентные и корпоративные прокси с гибкой оплатой.';
      default:
        return 'Learn more about SX.ORG — a leader in proxy services. We provide high-quality mobile, residential, and corporate proxies with flexible pricing.';
    }
  }

  const getTitleContacts = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Contact SX.ORG — Get in Touch';
      case 'ru':
        return 'Контакты SX.ORG — свяжитесь с нами';
      default:
        return 'Contact SX.ORG — Get in Touch';
    }
  }

  const getDescriptionContacts = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Contact SX.ORG to purchase proxy services. Our specialists will help you choose mobile, residential, or corporate proxies tailored to your needs.';
      case 'ru':
        return 'Свяжитесь с SX.ORG для покупки прокси-сервисов. Наши специалисты помогут подобрать мобильные, резидентные и корпоративные прокси под ваши задачи.';
      default:
        return 'Contact SX.ORG to purchase proxy services. Our specialists will help you choose mobile, residential, or corporate proxies tailored to your needs.';
    }
  }

  const getTitleFAQ = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Frequently Asked Questions — SX.ORG';
      case 'ru':
        return 'Часто задаваемые вопросы — SX.ORG';
      default:
        return 'Frequently Asked Questions — SX.ORG';
    }
  }

  const getDescriptionFAQ = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Find answers to common questions about SX.ORG proxy services. Learn how to use our mobile, residential, and corporate proxies for your business.';
      case 'ru':
        return 'Ответы на популярные вопросы о прокси-сервисах SX.ORG. Узнайте, как использовать наши мобильные, резидентные и корпоративные прокси для вашего бизнеса.';
      default:
        return 'Find answers to common questions about SX.ORG proxy services. Learn how to use our mobile, residential, and corporate proxies for your business.';
    }
  }

  const getTitleBlog = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Blog about proxies for business - SX.ORG';
      case 'ru':
        return 'Блог о прокси для бизнеса - SX.ORG';
      default:
        return 'Blog about proxies for business - SX.ORG';
    }
  }

  const getDescriptionBlog = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Articles about proxies and their use in business, marketing, SEO and more - SX.ORG';
      case 'ru':
        return 'Статьи о прокси и их использовании прокси в бизнесе, маркетинге, SEO и многом другом — SX.ORG';
      default:
        return 'Articles about proxies and their use in business, marketing, SEO and more - SX.ORG';
    }
  }

  const getTitleLawEnforcement = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Law Enforcement — SX.ORG';
      case 'ru':
        return 'Правоохранительным органам — SX.ORG';
      default:
        return 'Law Enforcement — SX.ORG';
    }
  }

  const getDescriptionLawEnforcement = () => {
    switch (localeI18n.value) {
      case 'en':
        return 'Information for law enforcement agencies';
      case 'ru':
        return 'Информация для правоохранительных органов';
      default:
        return 'Information for law enforcement agencies';
    }
  }

  const keyWords = computed(() => {
    switch (localeI18n.value) {
      case 'en':
        return 'android proxy, minecraft proxies, residential ip, proxy provider, proxy server website, use proxy, residential proxy, residential proxy, socks5 residential proxy, proxy server software, buy proxy, psiphon proxy, tor proxy, anonymous web proxy, windscribe proxy, chrome proxy, windows proxy, residential ip, proxy, residential mobile proxy, proxy for gaming, web scraping proxy, proxy provider, proxy residential trial, proxy host';
      case 'ru':
        return 'прокси сервер сети интернет, прокси сервер, купить прокси дешево, proxy сервер, мобильные прокси, резидентские прокси, купить прокси ipv4, прокси сайт';
      default:
        return 'android proxy, minecraft proxies, residential ip, proxy provider, proxy server website, use proxy, residential proxy, residential proxy, socks5 residential proxy, proxy server software, buy proxy, psiphon proxy, tor proxy, anonymous web proxy, windscribe proxy, chrome proxy, windows proxy, residential ip, proxy, residential mobile proxy, proxy for gaming, web scraping proxy, proxy provider, proxy residential trial, proxy host';
    }
  })

  return {
    getTitleHome,
    getDescriptionHome,
    getTitlePartners,
    getDescriptionPartners,
    getTitleGeo,
    getDescriptionGeo,
    getTitleCompare,
    getDescriptionCompare,
    getMobileProxyTitle,
    getMobileProxyDescription,
    getResidentProxyTitle,
    getResidentProxyDescription,
    getCorporateProxyTitle,
    getCorporateProxyDescription,
    getTitleErrorPage,
    getOurProxyTitle,
    getOurProxyDescription,
    getDevelopersTitle,
    getDevelopersDescription,
    getTitleAbout,
    getDescriptionAbout,
    getTitleContacts,
    getDescriptionContacts,
    getTitleFAQ,
    getDescriptionFAQ,
    getTitleBlog,
    getDescriptionBlog,
    getTitleLawEnforcement,
    getDescriptionLawEnforcement,
    keyWords,
  }
}